<template>
  <div class="container text-left">
    <CallUI/>
    <message-controller/>
    <user-bar></user-bar>
    <div class="text-left">
      <h1 class="text-left">Connected users:
        <button style="float: right; font-size: 2rem" @click="getConnectedUsers">Refresh users</button>
      </h1>
      <table style="width: 100%">
        <thead>
          <tr>
            <th>User</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(user,key) in users" :key="key">
            <td>{{ user.email }} (id: {{ user.id }})</td>
            <td>
              <button class="btn btn-danger btn-sm" @click="call(user)">Call</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div>
      <h3>Message tester</h3>
      <div><label>Target user (id):<br/><input type="number" v-model="target"></label></div>
      <div><label>Event name:<br/><input type="text" v-model="event"></label></div>
      <div><i>the event name must correspond to socket.on(eventName) as defined in socketPlugin.js<br/>available values:<br/>parrot - the target user responds with the message that was sent</i></div>
      <div><label>Await response:<br/><input type="checkbox" v-model="awaitResponse"></label></div>
      <div><label>Message text:<br/><textarea v-model="message"></textarea></label></div>
      <button @click="send">Send</button>
      <h4>Last received response:</h4>
      <div style="width: 400px; min-height: 120px; border: 1px solid black; margin-bottom: 8px" v-html="response"></div>
    </div>
  </div>
</template>

<script>
import UserBar from "@/components/userBar";
import eventHub from "@/mixins/eventHub";
import CallUI from "@/components/CallUI";
import MessageController from "@/components/messageController";

export default {
  name: "Calls",
  components: {MessageController, CallUI, UserBar},
  data() {
    return {
      users: [],
      micStream: null,
      message: 'some string',
      event: 'parrot',
      target: null,
      response: null,
      awaitResponse: true
    }
  },
  methods: {
    async send() {
      this.$store.dispatch('sendToUser', {id: this.target, message: this.message, event: this.event, awaitResponse: this.awaitResponse})
        .then((response) => {
          this.response = response
        })
        .catch((err) => {
          this.response = `Received an error!:<br/> ${err}`
        })
    },
    async getConnectedUsers() {
      this.users = await this.$store.dispatch('callApi', {name: 'getAvailableUsers'})
    },
    /**
     *
     * @param callee {{id: Number, email: String}}
     * @return {Promise<void>}
     */
    async call(callee) {
      console.log(callee);

      this.$store.dispatch('callUser', {to: callee}).catch((error)=>{
        eventHub.$emit('openMessageController', 'error', error)
        console.error(error.message);
      })
    }
  },
  mounted() {
    this.getConnectedUsers()
  }
}
</script>

<style scoped>
.calls {

}
</style>
